import { staticComponentValueConverter } from '../StaticComponentValues';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { useMemo } from 'react';
import { translate } from '../../../../../../../utils/language';
import { useSelector } from 'react-redux';

const staticData = {
  height: 30,
};

function Search_11({ item, imageWidth, aspectRatio, activeBigger, isCentered }) {
  const customization = staticComponentValueConverter(item?.customization);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const convertedStaticData = staticComponentValueConverter(staticData);
  const iconFilter = useMemo(() => HexToHueConverter(customization?.searchIconColor), [customization?.searchIconColor]);
  return (
    <div
      style={{
        padding: `${customization?.containerPadding}`,
        backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
        backgroundImage:
          customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 5,
      }}
    >
      <div
        style={{
          borderColor: `${customization?.borderColor}`,
          borderRadius: `${customization?.borderRadius}`,
          backgroundColor: customization?.innerBackgroundColor,
          flex: 1,
          height: staticValues[40],
        }}
      >
        <div
          style={{
            color: customization?.textColor,
            fontSize: customization?.textSize,
            minHeight: convertedStaticData.height,
            height: staticValues[40],
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            paddingLeft: staticValues[10],
          }}
        >
          {customization?.placeholder || 'Ara'}
        </div>
      </div>
      {customization?.isSearchIcon && (
        <div>
          <div
            style={{
              padding: 4,
              backgroundColor: customization?.searchIconBackgroundColor,
              color: customization?.searchIconColor,
              borderRadius: customization?.searchIconBorderRadius,
              height: staticValues[40],
              width: staticValues[40],
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={customization?.searchIcon}
              style={{ width: customization?.searchIconWidth, filter: iconFilter }}
              alt=""
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Search_11;
